// 20MB raw → ~26MB after base64 encoding, fits within 25MB SMTP limit with margin.
export const MAX_TOTAL_ATTACHMENT_SIZE = 20 * 1024 * 1024

export const ALLOWED_ATTACHMENT_TYPES = [
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/gif',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
]

// Type-confirm gate threshold for confirm dialog.
export const LARGE_SEND_THRESHOLD = 500

// Feature flag for the production "Invia Email" button. Keep `false` until UILDM
// signs off on enabling real bulk sends; the test-only button remains the only
// way to dispatch mail in the meantime.
export const IS_PRODUCTION_SEND_ENABLED = false

// Test send destination list. The "Invio di test" button routes every dispatch
// here regardless of the recipients filters selected in the form. Update this
// list with a code change when the test cohort changes.
export const MAILER_TEST_RECIPIENTS = [
    'luca.denni@humans.tech',
    'carlo.belli+777@humans.tech'
    // 'cristina.sancricca@fondazioneuildmlazio.org',
    // 'angela.mancini@fondazioneuildmlazio.org'
] as const
